import CryptoJS from 'crypto-js';

const SECRET_KEY = 'FABDROID@2025';

export default class ServiceUtil {
    saveEncrypted = (key, data) => {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        sessionStorage.setItem(key, encrypted);
    };

    getDecrypted = (key) => {
        const encrypted = sessionStorage.getItem(key);
        if (!encrypted) return null;
        const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    };

    parseCookies(rawSetCookie) {
        const cookies = {};
        const cookieStrings = rawSetCookie.split(',');
        for (var raw in cookieStrings) {
            const cookiePair = raw.split(';').first.trim();
            if (cookiePair.contains('=')) {
                const key = cookiePair.split('=').first.trim();
                const value = cookiePair.substring(cookiePair.indexOf('=') + 1).trim();
                cookies[key] = value;
            }
        }
        return cookies;
    }

    getStoredCookies() {
        const stored = sessionStorage.getItem("cookie");
        if (stored == null || stored.isEmpty) return {};
        const cookieMap = {};

        for (const pair in stored.split(';')) {
            if (pair.trim().isNotEmpty && pair.contains('=')) {
                const key = pair.split('=').first.trim();
                const value = pair.substring(pair.indexOf('=') + 1).trim();
                cookieMap[key] = value;
            }
        }

        return cookieMap;
    }

    saveCookies(cookies) {
        const cookieString = Object.entries(cookies)
            .map(([key, value]) => `${key}=${value}`)
            .join('; ');
        sessionStorage.setItem("cookie", cookieString);
    }
}